class CartPanel extends Panel {
  constructor() {
    super();
    this.contentElement = this.querySelector('cart-panel');
  }
  connectedCallback() {
    super.connectedCallback();
    this.getContent('#cart', 'dynamic-cart-content');
  }

  getContent(queryId, sectionId) {
    fetch(`/cart?section_id=${sectionId}`)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;

        const details = html.querySelector(queryId);
        this.querySelectorAll('[data-dynamic-cart-content]').forEach((x) => x.remove());
        this.insertAdjacentHTML('beforeend', details.innerHTML);
      })
      .catch((e) => {
        console.error(e);
      });
  }

  refreshCartPanel() {
    const cartContent = document.querySelector('cart-panel');
    fetch(`/cart?section_id=dynamic-cart-content`)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const details = html.querySelector('#cart');
        cartContent.querySelectorAll('[data-dynamic-cart-content]').forEach((x) => x.remove());
        cartContent.insertAdjacentHTML('beforeend', details.innerHTML);
        // this.addScrollEvent();
      })
      .catch((e) => {
        console.error(e);
      });
  }

  transitionFrom(previousState, newState, triggerElement, previousPanel) {
    //super.transitionFrom(previousState, newState, triggerElement, previousPanel);
    this.activate();
    if (previousState === 'idle') {
      actions.openRightBottomNav().then(() => {
        window.trapFocus(this, this.defaultFocus, triggerElement);
      });
    } else {
      if (previousPanel) {
        window.trapFocus(this, this.defaultFocus, triggerElement);
        previousPanel.deactivate();
      }
    }
  }

  // addScrollEvent() {
  //   setTimeout(() => {
  //     this.contentScroller = this.querySelector('.side-cart-scroller');
  //     if (this.contentScroller) {
  //       this.contentScroller.addEventListener('scroll', this.onContentScroll.bind(this));
  //     }
  //   }, 400);
  // }
  onContentScroll() {
    // if (this.contentScroller.scrollTop > 0) {
    //   this.classList.add('scrolling');
    // } else {
    //   this.classList.remove('scrolling');
    // }
  }
}
customElements.define('cart-panel', CartPanel);
